import { Route, Switch, useLocation } from "wouter"
import LandingPage from "@/pages/LandingPage"
import DashboardPage from "@/pages/DashboardPage"
import StudioPage from "@/pages/StudioPage"
import FilmGrain from "@/components/FilmGrain"
import AuthPage from "@/pages/AuthPage"
import AuthSessionBootstrap from "@/components/AuthSessionBootstrap"

function App() {
  const [location] = useLocation()
  const isStudio = location.startsWith("/studio")

  return (
    <>
      <AuthSessionBootstrap />
      {!isStudio && <FilmGrain />}
      <Switch>
        <Route path="/" component={LandingPage} />
        <Route path="/sign-in">{() => <AuthPage mode="sign-in" />}</Route>
        <Route path="/sign-up">{() => <AuthPage mode="sign-up" />}</Route>
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/studio/:tab?" component={StudioPage} />
        <Route>{
          () => {
            window.location.href = "/"
            return null
          }
        }</Route>
      </Switch>
    </>
  )
}

export default App
